"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tealium = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const baseLibrary_1 = require("../baseLibrary");
const determineBaseUrl_1 = require("./utils/determineBaseUrl");
class MbTealium extends baseLibrary_1.BaseLibrary {
    constructor(baseUrl) {
        super();
        this.baseUrl = baseUrl;
    }
    async load() {
        if (window.COUNTRY && window.COUNTRY.trim()) {
            this.instance = new web_ui_framework_1.Tealium(this.baseUrl);
            await this.instance.load();
        }
        else {
            web_ui_framework_1.Log.warn('Tealium: There is no valid COUNTRY configured');
        }
    }
}
const baseUrl = (0, determineBaseUrl_1.determineBaseUrl)();
const Tealium = new MbTealium(baseUrl);
exports.Tealium = Tealium;
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map